import React from 'react';
import Item from '../Item';
/**
 * Build an array of page buttons depending upon the currently selected item
 * and page total.
 */
function pageBuilder(selected, totalPages) {
  let pageObjectArray = [];
  [...Array(totalPages).keys()].map(index =>
    pageObjectArray.push({
      text: (index + 1).toString(),
      selected: selected === index + 1
    })
  );

  let pageElementArray = [];
  pageObjectArray.map((page, index) => {
    let indexNum = index + 1;
    if (selected <= 7 && totalPages <= 7) {
      pageElementArray.push(
        <Item key={page.text} text={page.text} selected={page.selected} />
      );
    }

    if (selected <= 4 && totalPages > 7) {
      if (indexNum <= 5 || indexNum === totalPages) {
        pageElementArray.push(
          <Item key={page.text} text={page.text} selected={page.selected} />
        );
      }
      if (indexNum === 6) {
        pageElementArray.push(<Item key={indexNum} text="..." disabled />);
      }
    }

    if (selected >= totalPages - 3 && totalPages > 7) {
      if (indexNum === 1) {
        pageElementArray.push(
          <Item key={page.text} text={page.text} selected={page.selected} />
        );
      }
      if (indexNum === 2) {
        pageElementArray.push(<Item key={page.text} text="..." disabled />);
      }
      if (indexNum >= totalPages - 4) {
        pageElementArray.push(
          <Item key={page.text} text={page.text} selected={page.selected} />
        );
      }
    }

    if (selected >= 5 && selected <= totalPages - 4 && totalPages > 7) {
      if (indexNum === 1) {
        pageElementArray.push(
          <Item key={page.text} text={page.text} selected={page.selected} />
        );
      }
      if (indexNum === 2) {
        pageElementArray.push(<Item key={page.text} text="..." disabled />);
      }
      if (
        indexNum === selected - 1 ||
        indexNum === selected ||
        indexNum === selected + 1
      ) {
        pageElementArray.push(
          <Item key={page.text} text={page.text} selected={page.selected} />
        );
      }
      if (indexNum === totalPages - 1) {
        pageElementArray.push(<Item key={page.text} text="..." disabled />);
      }
      if (indexNum === totalPages) {
        pageElementArray.push(
          <Item key={page.text} text={page.text} selected={page.selected} />
        );
      }
    }
  });

  return pageElementArray;
}

export { pageBuilder };
